<!-- 设备管理 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('设备类型')">
                <j-dict-select-tag v-model="queryParam.deviceType" :dictCode="'deviceType'" :showSearch="false" :placeholder="$t('请选择设备类型')" />
              </a-form-item>
            </a-col>
            <a-col :xl="7" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('时间范围')">
                <a-range-picker show-time v-model="date" valueFormat="YYYY-MM-DD HH:mm:ss" @change="onChange" style="width: 100%;" />
              </a-form-item>
            </a-col>
            <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic;">{{ $t('无图片') }}</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic;">{{ $t('无文件') }}</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="problemLevel" slot-scope="text">
          <a-tag color="#E53333" v-if="text == 0">{{ filterDictTextByCache('problemLevel',text) }}</a-tag>
          <a-tag color="#FF9900" v-else-if="text == 1">{{ filterDictTextByCache('problemLevel',text) }}</a-tag>
          <a-tag color="#FFE500" v-else-if="text == 2">{{ filterDictTextByCache('problemLevel',text) }}</a-tag>
          <a-tag color="#337FE5" v-else>{{ filterDictTextByCache('problemLevel',text) }}</a-tag>
        </span>
        <span slot="ticketsNum" slot-scope="text,record">
          <a @click="handleRouter(record)">{{ text }}</a>
        </span>
        <span slot="action" slot-scope="text, record">
          <template v-if="record.status === 0">
            <a @click="handleConfirm(record)">{{ $t('确认') }}</a>
            <a-divider type="vertical" />
            <a @click="handleReject(record)">{{ $t('驳回') }}</a>
            <a-divider type="vertical" />
            <a @click="handleStop(record)">{{ $t('搁置') }}</a>
            <a-divider type="vertical" />
          </template>
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <ConfirmModal ref="ConfirmModalRef" @ok="modalFormOk" />
    <AddProblemModal ref="addProblemModalRef" />
    <rejectAndStopModal ref="rejectAndStopModalRef" @ok="modalFormOk"/>
    <ConfirmIsOrderModal ref="ConfirmIsOrderModalRef" @ok="modalFormOk"/>
  </a-card>
</template>
  
  <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { httpAction, getAction, postAction } from '@/api/manage'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import ConfirmModal from './ConfirmModal.vue'
import AddProblemModal from './AddProblemModal.vue'
import rejectAndStopModal from './rejectAndStopModal.vue'
import ConfirmIsOrderModal from './ConfirmIsOrderModal.vue'
import Vue from 'vue'
import { SYS_TYPE } from "@/store/mutation-types"
import store from '@/store/'

export default {
  name: 'lineList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    ConfirmModal,
    AddProblemModal,
    rejectAndStopModal,
    ConfirmIsOrderModal
  },
  data() {
    return {
      description: '问题确认',
      filterDictTextByCache: filterDictTextByCache,
      url: {
        list: '/jeecg-engineering/InspectionWorkOrderController/workOrderList',
        edit: '/jeecg-engineering/InspectionWorkOrderController/exampleModifyTheInspectionWorkOrder',
        workOrderDetails: '/jeecg-engineering/InspectionWorkOrderController/workOrderDetails',
      },
      dictOptions: {},
      superFieldList: [],
      date: [],
      queryParam: {
        source: 1
      }
    }
  },
  created() {},
  computed: {
    columns() {
            return [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 60,
              align: 'center',
              customRender: (t, r, index) => {
                return parseInt(index) + 1
              },
            },
            {
              title: this.$t('上报人'),
              align: 'center',
              dataIndex: 'informant',
            },
            {
              title: this.$t('上报人电话'),
              align: 'center',
              dataIndex: 'informantPhone',
            },
            {
              title: this.$t('问题等级'),
              align: 'center',
              dataIndex: 'problemLevel',
              scopedSlots: { customRender: 'problemLevel' },
            },
            {
              title: this.$t('设备类型'),
              align:"center",
              dataIndex: 'deviceType',
              customRender: (text) => {
                return filterDictTextByCache('deviceType',text)
              }
            },
            {
              title: this.$t('设备名称'),
              align:"center",
              dataIndex: 'deviceName'
            },
            {
              title: this.$t('状态'),
              align: 'center',
              dataIndex: 'status',
              customRender: (text) => {
                return { 0: this.$t('未确认'), 1: this.$t('已确认'), 2: this.$t('驳回'), 3: this.$t('搁置'), 4: this.$t('已完成'),5: this.$t('工单处理中') }[text]
              },
            },
            {
              title: this.$t('创建时间'),
              align: 'center',
              dataIndex: 'createTime',
            },
            {
              title: this.$t('关联工单'),
              align: 'center',
              dataIndex: 'ticketsNum',
              scopedSlots: { customRender: 'ticketsNum' },
            },
            {
              title: this.$t('操作'),
              dataIndex: 'action',
              align: 'center',
              fixed: 'right',
              width: 150,
              scopedSlots: { customRender: 'action' },
            },
          ]
          }
  },
  methods: {
    onChange(e){
      this.queryParam.startTime = e[0];
      this.queryParam.endTime = e[1];
      this.loadData();
    },
    loadData() {
      let params = this.getQueryParams()
      params.statusList = [0]
      postAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleConfirm(record) {
      // this.$refs.ConfirmModalRef.init(record)
      this.$refs.ConfirmIsOrderModalRef.init(record)
    },
    handleReject(record) {
      this.$refs.rejectAndStopModalRef.init(record,2)
    },
    handleStop(record) {
      this.$refs.rejectAndStopModalRef.init(record,3)
    },
    handleDetail(row) {
      this.$refs.addProblemModalRef.init(row)
    },
    handleRouter(row){
      Vue.ls.set(SYS_TYPE,8);
      store.commit('SET_SYSTYPE', 8);
      this.$router.push({ 
        path: "/workOrderManagement/workManagement/indexWaterWorks",
        query: { ticketsNum: row.ticketsNum } 
      });
    },
    searchReset(){
      this.queryParam = {
        source: 1,
      };
      this.loadData();
    },
  },
}
</script>
  <style scoped>
@import '~@assets/less/common.less';
</style>